import React from "react";

import {
    BottomButton,
    BottomSection,
    ContentCard,
    ContentSection,
    HeaderBar,
    SkeletonContainer,
    TabsPill,
    TabsSection,
} from "./styles";

/**
 * Full page skeleton shown during initial page load
 */
export const CartOrdersPageSkeleton: React.FC = () => {
    return (
        <SkeletonContainer>
            <HeaderBar />

            <TabsSection>
                <TabsPill />
            </TabsSection>

            <ContentSection>
                <ContentCard />
                <ContentCard />
            </ContentSection>

            <BottomSection>
                <BottomButton />
            </BottomSection>
        </SkeletonContainer>
    );
};

export default CartOrdersPageSkeleton;
